var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get } from '../../../utils/get';
import { CONTEXT_PROPS } from '../../../types/ContextProps';
import { IDs } from '../adapter-challenges-page';
import { getImageObject } from '../../../adapters/structure-data-utils';
export var renderStructureData = function (item, calculatedData) {
    if (calculatedData[IDs.SD_DISABLE_SCHEMA]) {
        return {};
    }
    var _a = calculatedData, _b = IDs.NAME, name = _a[_b], _c = IDs.DESCRIPTION, description = _a[_c], _d = IDs.CALCULATED_MAIN_IMAGE_URL, mainImageUrl = _a[_d], _e = IDs.IMAGE_HEIGHT, imageHeight = _a[_e], _f = IDs.IMAGE_WIDTH, imageWidth = _a[_f], _g = IDs.URL, url = _a[_g], _h = IDs.PRICE, price = _a[_h], _j = IDs.CURRENCY, priceCurrency = _a[_j];
    return __assign(__assign(__assign({ '@context': 'https://schema.org', '@type': 'WebPage', name: name }, (description ? { description: description } : {})), getImageObject('image', mainImageUrl, imageWidth, imageHeight)), { offers: {
            '@type': 'Offer',
            url: url,
            priceCurrency: priceCurrency,
            price: price,
            availability: 'https://schema.org/OnlineOnly',
            seller: {
                '@type': 'Organization',
                name: get(item, "context." + CONTEXT_PROPS.BUSINESS_NAME),
            },
        } });
};
